import type { RouteRecordRaw } from 'vue-router';

/** 라우트는 항상 등록 — production lettaga.ai 접근은 router guard에서 차단 */
const marketingRoutes: RouteRecordRaw[] = [
    {
        name: 'MarketingSendWhatsApp',
        path: 'marketing/whatsapp',
        component: () => import('@/views/marketing/SendWhatsAppMessage.vue'),
    },
    {
        name: 'MarketingWhatsAppBlock',
        path: 'marketing/whatsapp-block',
        component: () => import('@/views/marketing/WhatsAppBlockManagement.vue'),
    },
];

const sellbiRoutes: RouteRecordRaw[] = [
    {
        path: 'sellbi',
        redirect: 'sellbi/analytics',
    },
    {
        name: 'SellbiMembers',
        path: 'sellbi/members',
        component: () => import('@/views/sellbi/SellbiMembers.vue'),
    },
    {
        name: 'SellbiListings',
        path: 'sellbi/listings',
        component: () => import('@/views/sellbi/SellbiListings.vue'),
    },
    {
        name: 'SellbiListingDetail',
        path: 'sellbi/listings/:id',
        component: () => import('@/views/sellbi/SellbiListingDetail.vue'),
        props: true,
    },
    {
        // 대행 편집 — 셀러 수정화면(MyListing) 이식본. 상세화면의 [편집]에서 진입.
        name: 'SellbiListingEdit',
        path: 'sellbi/listings/:id/edit',
        component: () => import('@/views/sellbi/SellbiListingEdit.vue'),
        props: true,
    },
    {
        name: 'SellbiDeals',
        path: 'sellbi/deals',
        component: () => import('@/views/sellbi/SellbiDeals.vue'),
    },
    {
        name: 'SellbiDealDetail',
        path: 'sellbi/deals/:id',
        component: () => import('@/views/sellbi/SellbiDealDetail.vue'),
        props: true,
    },
    {
        name: 'SellbiAnalytics',
        path: 'sellbi/analytics',
        component: () => import('@/views/sellbi/SellbiAnalytics.vue'),
    },
    {
        name: 'SellbiLeads',
        path: 'sellbi/leads',
        component: () => import('@/views/sellbi/SellbiLeads.vue'),
    },
    {
        name: 'SellbiManagers',
        path: 'sellbi/managers',
        component: () => import('@/views/sellbi/SellbiManagers.vue'),
    },
];

const MainRoutes: RouteRecordRaw = {
    path: '/main',
    meta: {
        requiresAuth: true
    },
    component: () => import('@/layouts/full/FullLayout.vue'),
    children: [
        {
            path: '',
            redirect: "dashboards/general",
        },
        {
            name: 'General',
            path: 'dashboards/general',
            component: () => import('@/views/dashboards/general/index.vue'),
        },
        ...marketingRoutes,
        ...sellbiRoutes,
        {
            name: 'MyLettagaClients',
            path: 'mylettaga/clients',
            component: () => import('@/views/mylettaga/ClientsManagement.vue'),
        },
        {
            name: 'MyLettagaUsers',
            path: 'mylettaga/users',
            component: () => import('@/views/mylettaga/UsersManagement.vue'),
        },
        {
            name: 'MyLettagaIncorporations',
            path: 'mylettaga/incorporations',
            component: () => import('@/views/mylettaga/IncorporationLeads.vue'),
        },
        {
            name: 'MyLettagaLinks',
            path: 'mylettaga/links',
            component: () => import('@/views/mylettaga/LinkManagement.vue'),
        },
        {
            name: 'MyLettagaPartnerFirms',
            path: 'mylettaga/partner-firms',
            component: () => import('@/views/mylettaga/PartnerFirmApplications.vue'),
        },
        {
            name: 'MyLettagaPush',
            path: 'mylettaga-push',
            component: () => import('@/views/mylettaga-push/MyLettagaPush.vue'),
        },
        {
            name: 'DocumentEdit',
            path: 'doc-manager/document-edit',
            component: () => import('@/views/doc-manager/DocumentEdit.vue'),
        },
        {
            name: 'DocumentTemplateEditor',
            path: 'doc-manager/document-edit/:id',
            component: () => import('@/views/doc-manager/TemplateEditor.vue'),
        },
        {
            name: 'DocumentVariableManagement',
            path: 'doc-manager/document-variables',
            component: () => import('@/views/doc-manager/DocumentVariableManagement.vue'),
        },
        {
            name: 'RAGIndexView',
            path: 'doc-manager/rag-index',
            component: () => import('@/views/doc-manager/RAGIndexView.vue'),
        },
        {
            name: 'AiVariableRules',
            path: 'doc-manager/ai-variable-rules',
            component: () => import('@/views/doc-manager/AiVariableRules.vue'),
        },
        // Clients Management
        {
            name: 'ClientList',
            path: 'clients',
            component: () => import('@/views/clients/ClientList.vue'),
        },
        {
            name: 'ClientEmailConfig',
            path: 'clients/email-config',
            component: () => import('@/views/clients/email-config/ClientEmailConfig.vue'),
        },
        {
            name: 'DeepLinkManagement',
            path: 'clients/deep-link',
            component: () => import('@/views/clients/deep-link/DeepLinkManagement.vue'),
        },
        {
            name: 'OfficerExcelDownload',
            path: 'clients/officer-excel',
            component: () => import('@/views/clients/OfficerExcelDownload.vue'),
        },
        // Log Manager
        {
            name: 'LoginLogs',
            path: 'log-manager/login-logs',
            component: () => import('@/views/log-manager/LoginLogs.vue'),
        },
        {
            name: 'Reminders',
            path: 'log-manager/reminders',
            component: () => import('@/views/log-manager/Reminders.vue'),
        },
        {
            name: 'EmailSendLogs',
            path: 'log-manager/email-send-logs',
            component: () => import('@/views/log-manager/EmailSendLogs.vue'),
        },
        {
            name: 'ServerLogs',
            path: 'log-manager/server-logs',
            component: () => import('@/views/log-manager/ServerLogs.vue'),
        },
        // Email Policy
        {
            name: 'EmailSuppression',
            path: 'email/suppression',
            component: () => import('@/views/email-policy/EmailSuppression.vue'),
        },
        // Basecode Management
        {
            name: 'BasecodeManagement',
            path: 'basecode',
            component: () => import('@/views/basecode/BasecodeManagement.vue'),
        },
        // Asset Management
        {
            name: 'AssetManagement',
            path: 'asset-management',
            component: () => import('@/views/asset-management/AssetManagement.vue'),
        },
        // KEY MAP Management
        {
            name: 'KeyMapManagement',
            path: 'key-map',
            component: () => import('@/views/key-map/KeyMapManagement.vue'),
        },
        // Menu Management
        {
            name: 'MenuManagement',
            path: 'menu-management',
            component: () => import('@/views/menu-management/MenuManagement.vue'),
        },
        // Entity CSV Upload
        {
            name: 'EntityCsvUpload',
            path: 'entity/csv-upload',
            component: () => import('@/views/entity/EntityCsvUpload.vue'),
        },
        // Marketplace Subscriptions Management
        {
            name: 'MarketplaceSubscriptions',
            path: 'marketplace/subscriptions',
            component: () => import('@/views/marketplace/SubscriptionsManagement.vue'),
        },
        // Marketplace Pricing Management
        {
            name: 'MarketplacePricing',
            path: 'marketplace/pricing',
            component: () => import('@/views/marketplace/PricingManagement.vue'),
        },
        // Marketplace My Preset Requests (approval)
        {
            name: 'MarketplacePresetRequests',
            path: 'marketplace/preset-requests',
            component: () => import('@/views/marketplace/PresetRequestManagement.vue'),
        },
        // Marketplace API Keys Management
        {
            name: 'MarketplaceApiKeysManagement',
            path: 'marketplace/api-keys',
            component: () => import('@/views/marketplace/ApiKeysManagement.vue'),
        },
        // Marketplace API Test
        {
            name: 'MarketplaceApiTest',
            path: 'marketplace/api-test',
            component: () => import('@/views/marketplace/ApiTestPage.vue'),
        },
        {
            name: 'LettagaApiTest',
            path: 'development/lettaga-api-test',
            component: () => import('@/views/development/LettagaApiTest.vue'),
        },
        // Batch Manager
        {
            name: 'BatchManager',
            path: 'batch-manager',
            component: () => import('@/views/batch-manager/BatchManager.vue'),
        },
        // S2000 Migration
        {
            name: 'S2000Migration',
            path: 'migration/s2000',
            component: () => import('@/views/migration/S2000Migration.vue'),
        },
        // SPC Migration
        {
            name: 'SPCMigration',
            path: 'migration/spc',
            component: () => import('@/views/migration/SPCMigration.vue'),
        },
        // Teamwork Register Migration
        {
            name: 'TeamworkMigration',
            path: 'migration/teamwork',
            component: () => import('@/views/migration/TeamworkMigration.vue'),
        },
        // Data Copy Migration
        {
            name: 'DataCopyMigration',
            path: 'migration/data-copy',
            component: () => import('@/views/migration/DataCopyMigration.vue'),
        },
        // Entity View
        {
            name: 'EntityView',
            path: 'entity-view',
            component: () => import('@/views/entity-view/EntityView.vue'),
        },
        // Legal Documents (Terms/Privacy/DPA) + Consent
        {
            name: 'LegalDocumentManagement',
            path: 'legal/documents',
            component: () => import('@/views/legal/LegalDocumentManagement.vue'),
        },
        {
            name: 'LegalConsentStatus',
            path: 'legal/consent',
            component: () => import('@/views/legal/ConsentStatus.vue'),
        },
        // Billing Management
        {
            name: 'BillingPlanManagement',
            path: 'billing/plans',
            component: () => import('@/views/billing/PlanManagement.vue'),
        },
        {
            name: 'BillingSubscriptionManagement',
            path: 'billing/subscriptions',
            component: () => import('@/views/billing/SubscriptionManagement.vue'),
        },
        {
            name: 'BillingPaymentHistory',
            path: 'billing/payments',
            component: () => import('@/views/billing/PaymentHistory.vue'),
        },
        {
            name: 'BillingScheduleManagement',
            path: 'billing/schedules',
            component: () => import('@/views/billing/ScheduleManagement.vue'),
        },
        {
            name: 'BillingPromoCodes',
            path: 'billing/promo-codes',
            component: () => import('@/views/billing/PromoCodeManagement.vue'),
        },
        {
            name: 'BillingEmailOutbox',
            path: 'billing/email-outbox',
            component: () => import('@/views/billing/EmailOutbox.vue'),
        },
        // PreSet Management
        {
            name: 'PreSetManagement',
            path: 'preset',
            component: () => import('@/views/preset/PreSetManagement.vue'),
        },
        // My PreSet Management (클라이언트별 커스텀 프리셋)
        {
            name: 'MyPreSetManagement',
            path: 'mypreset',
            component: () => import('@/views/mypreset/MyPreSetManagement.vue'),
        },
        // Notice Management (전역 페이지별 공지)
        {
            name: 'NoticeManagement',
            path: 'notice-management',
            component: () => import('@/views/notice-management/NoticeManagement.vue'),
        },
    ]
};

export default MainRoutes;
